<template>
  <a-drawer
    :maskClosable="false"
    width="80%"
    title="详情"
    placement="right"
    :closable="true"
    :visible="visible"
    @close="onClose"
  >
    <a-tabs @change="callback" :activeKey="active" type="card">
      <a-tab-pane :key="1" tab="已关联商品">
        <div class="table-page-search-wrapper">
          <a-form layout="inline" labelAlign="right">
            <a-row :gutter="48">
              <a-col :md="6" :sm="24">
                <a-form-item label="商品名称">
                  <a-input v-model="queryParam.prodName" placeholder="请输入商品名称" allow-clear />
                </a-form-item>
              </a-col>
              <a-col :md="(!advanced && 6) || 24" :sm="24">
                <span
                  class="table-page-search-submitButtons"
                  :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}"
                >
                  <!-- <a-button
                    type="primary"
                    @click="$refs.createForm.handleAdd()"
                    v-hasPermi="['f83dab0860c8732ec77cbc1ddee72448b:0:b']"
                  >
                    <a-icon type="plus" />新增
                  </a-button> -->
                  <a-button
type="primary"
@click="handleQuery"
style="margin-left: 8px"
                    ><a-icon type="search" />查询</a-button
                  >
                  <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
                  <!-- <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'" />
                </a> -->
                </span>
              </a-col>
            </a-row>
          </a-form>
        </div>
        <!-- 数据展示 -->
        <!-- 数据展示 -->
        <a-table
          :loading="loading"
          :size="tableSize"
          rowKey="postId"
          :columns="columns"
          :data-source="list"
          :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
          :pagination="false"
          :bordered="tableBordered"
        >
          <span slot="pic" slot-scope="text, record">
            <div v-viewer>
              <img :src="$url + record.prodPic" alt="" style="width: 50px; height: 50px" />
            </div>
            <!-- <a-avatar :src="$url + record.pic" shape="square" size="large"> </a-avatar> -->
          </span>
          <span slot="createTime" slot-scope="text, record">
            {{ parseTime(record.createTime) }}
          </span>
          <span slot="prodType" slot-scope="text, record">
            {{
              record.prodType == 0
                ? '普通商品'
                : record.prodType === 1
                ? '拼团'
                : record.prodType == 2
                ? '秒杀'
                : '积分'
            }}
          </span>
          <!-- <span slot="status" slot-scope="text, record">
          <dict-tag :options="dict.type['sys_normal_disable']" :value="record.status" />
        </span> -->
          <span slot="pssnums" slot-scope="text, record">
            <div>原价： {{ record.oriPrice }}</div>
            <div>现价： {{ record.price }}</div>
            <div>销量：{{ record.soldNum }}</div>
            <!-- <div class="" style="color: #1890ff; cursor: pointer">
              <div @click.stop="handleStock(record)">库存：{{ record.totalStocks }}</div>
              <a-input
                v-model="stocks"
                @keyup.enter="handleStocks"
                placeholder="请输入库存"
                v-if="record.isStocks"
                oninput="value=value.replace(/[^\d]/g,'')"
              ></a-input>
            </div> -->
          </span>
          <span slot="status" slot-scope="text, record">
            <!-- <dict-tag :options="dict.type['goods_onsale']" :value="record.status" />
            <template v-if="categoryId">
              <a-tag color="red" v-if="record.status == 0"> 下架 </a-tag>
              <a-tag color="green" v-else> 上架 </a-tag>
            </template>
<template v-else>
              <a-popconfirm
                ok-text="是"
                cancel-text="否"
                @confirm="confirmHandleStatus(record)"
                @cancel="cancelHandleStatus(record)"
              >
                <span slot="title"
                  >确认<b>{{ record.status === 1 ? '下架' : '上架' }}</b
                  >吗?</span
                >
                <a-switch
                  checked-children="上架"
                  v-hasPermi="['abm-integral:prod:edit']"
                  un-checked-children="下架"
                  :checked="record.status == 1"
                />
              </a-popconfirm>
            </template> -->
            {{
              record.status == -1
                ? '删除'
                : record.status == 0
                ? '商家下架'
                : record.status == 1
                ? '上架'
                : record.status == 2
                ? '违规下架'
                : '平台审核'
            }}
          </span>
        </a-table>
        <!-- 分页 -->
        <a-pagination
          class="ant-table-pagination"
          show-size-changer
          show-quick-jumper
          :current="queryParam.pageNum"
          :total="total"
          :page-size="queryParam.pageSize"
          :showTotal="(total) => `共 ${total} 条`"
          @showSizeChange="onShowSizeChange"
          @change="changeSize"
        />
      </a-tab-pane>
      <a-tab-pane :key="3" tab="可关联商品">
        <div class="table-page-search-wrapper">
          <a-form layout="inline" labelAlign="right">
            <a-row :gutter="48">
              <a-col :md="6" :sm="24">
                <a-form-item label="商品名称">
                  <a-input v-model="queryParam.prodName" placeholder="请输入商品名称" allow-clear />
                </a-form-item>
              </a-col>
              <a-col :md="(!advanced && 6) || 24" :sm="24">
                <span
                  class="table-page-search-submitButtons"
                  :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}"
                >
                  <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                  <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
                  <!-- <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'" />
                </a> -->
                </span>
              </a-col>
            </a-row>
          </a-form>
        </div>
        <!-- 数据展示 -->
        <a-table
          :loading="loading"
          :size="tableSize"
          rowKey="skuId"
          :columns="columns"
          :data-source="list"
          :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
          :pagination="false"
          :bordered="tableBordered"
        >
          <span slot="pic" slot-scope="text, record">
            <div v-viewer>
              <img :src="$url + record.prodPic" alt="" style="width: 50px; height: 50px" />
            </div>
            <!-- <a-avatar :src="$url + record.pic" shape="square" size="large"> </a-avatar> -->
          </span>
          <span slot="createTime" slot-scope="text, record">
            {{ parseTime(record.createTime) }}
          </span>
          <span slot="prodType" slot-scope="text, record">
            {{
              record.prodType == 0
                ? '普通商品'
                : record.prodType === 1
                ? '拼团'
                : record.prodType == 2
                ? '秒杀'
                : '积分'
            }}
          </span>
          <!-- <span slot="status" slot-scope="text, record">
          <dict-tag :options="dict.type['sys_normal_disable']" :value="record.status" />
        </span> -->
          <span slot="pssnums" slot-scope="text, record">
            <div>原价： {{ record.oriPrice }}</div>
            <div>现价： {{ record.price }}</div>
            <div>销量：{{ record.soldNum }}</div>
            <!-- <div class="" style="color: #1890ff; cursor: pointer">
              <div @click.stop="handleStock(record)">库存：{{ record.totalStocks }}</div>
              <a-input
                v-model="stocks"
                @keyup.enter="handleStocks"
                placeholder="请输入库存"
                v-if="record.isStocks"
                oninput="value=value.replace(/[^\d]/g,'')"
              ></a-input>
            </div> -->
          </span>
          <span slot="status" slot-scope="text, record">
            <!-- <dict-tag :options="dict.type['goods_onsale']" :value="record.status" />
            <template v-if="categoryId">
              <a-tag color="red" v-if="record.status == 0"> 下架 </a-tag>
              <a-tag color="green" v-else> 上架 </a-tag>
            </template>
            <template v-else>
              <a-popconfirm
                ok-text="是"
                cancel-text="否"
                @confirm="confirmHandleStatus(record)"
                @cancel="cancelHandleStatus(record)"
              >
                <span slot="title"
                  >确认<b>{{ record.status === 1 ? '下架' : '上架' }}</b
                  >吗?</span
                >
                <a-switch
                  checked-children="上架"
                  v-hasPermi="['abm-integral:prod:edit']"
                  un-checked-children="下架"
                  :checked="record.status == 1"
                />
              </a-popconfirm>
            </template> -->
            {{
              record.status == -1
                ? '删除'
                : record.status == 0
                ? '商家下架'
                : record.status == 1
                ? '上架'
                : record.status == 2
                ? '违规下架'
                : '平台审核'
            }}
          </span>
        </a-table>
        <!-- 分页 -->
        <a-pagination
          class="ant-table-pagination"
          show-size-changer
          show-quick-jumper
          :current="queryParam.pageNum"
          :total="total"
          :page-size="queryParam.pageSize"
          :showTotal="(total) => `共 ${total} 条`"
          @showSizeChange="onShowSizeChange"
          @change="changeSize"
        />
      </a-tab-pane>
    </a-tabs>
    <create-form ref="createForm" :userList="userList" :statusOptions="dict.type['sys_enable_disable']" @ok="getList" />
    <div><a-button type="primary" :disabled="multiple" v-if="active == 3" @click="onadd()"> 添加商品 </a-button></div>
  </a-drawer>
</template>
<script>
import { bindProduct, fetchList2, fetchList3 } from '@/api/declaration/grouping'
import CreateForm from '@/views/declaration/groupTags/modules/CreateForm.vue'
export default {
  name: 'Post',
  components: {
    CreateForm,
  },
  data() {
    return {
      userList: [],
      visible: false,
      form: {
        skuId: 0,
        sort: 0,
        tagId: 0,
      },
      dataForm: {},
      errorImage: require('/src/assets/images/defaultImg.png'),
      active: 1,
      placeholderImage: '~@/assets/images/defaultImg.png',
      default: 'this.src="' + require('@/assets/images/defaultImg.png') + '"',
      total: 0,
      list: [],
      queryParam: {
        pageNum: 1,
        pageSize: 10,
        prodName: null,
        tagId: null,
      },
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      tableSize: 'small',
      selectedRowKeys: [],
      selectedRows: [],
      tableBordered: false,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      columns: [
        // {
        //   title: '商品分类',
        //   dataIndex: 'categoryName',
        //   ellipsis: true,
        //   align: 'left',
        //   width: 200,
        //   scopedSlots: { customRender: 'categoryName' },
        // },
        {
          title: '商品名称',
          dataIndex: 'prodName',
          ellipsis: true,
          align: 'left',
          scopedSlots: { customRender: 'prodName' },
        },
        {
          title: '商品图片',
          dataIndex: 'pic',
          ellipsis: true,
          align: 'center',

          scopedSlots: { customRender: 'pic' },
        },
        {
          title: '规格名称',
          dataIndex: 'skuName',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'skuName' },
        },
        // {
        //   title: '原价/现价/销量',
        //   dataIndex: 'pssnums',
        //   align: 'left',
        //   width: 120,
        //   scopedSlots: { customRender: 'pssnums' },
        // },
        // {
        //   title: '上架状态',
        //   dataIndex: 'status',
        //   scopedSlots: { customRender: 'status' },
        //   align: 'center',
        // },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          align: 'center',
        },
      ],
    }
  },
  dicts: ['sys_enable_disable'],
  filters: {},
  created() {
    this.type = 1
  },
  computed: {
    hasPermission() {
      return (permission) => {
        if (this.$store.state.user.userTentant.type === 0) {
          return true
        } else {
          return this.$store.state.user.permissions.includes(permission)
        }
        // return true
      }
    },
  },
  watch: {},
  methods: {
    init(e, index) {
      this.queryParam.tagId = e.id

      this.active = index
      this.getList()
      this.visible = true
    },
    onadd() {
      const data = {
        tagId: this.queryParam.tagId,
        skuIds: this.ids,
        sort: this.form.sort,
      }
      bindProduct(data)
        .then((response) => {
          if (response.data) {
            this.$message.success('添加成功')
            this.ids = []
            this.selectedRowKeys = []
            this.selectedRows = []
            this.$forceUpdate()
            this.getList()
          }
        })
        .finally(() => {})
    },

    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam.pageNum = 1
      this.queryParam.pageSize = 10

      this.queryParam.prodName = null

      this.handleQuery()
    },
    getList() {
      this.loading = true
      if (this.active == 1) {
        fetchList2(this.queryParam).then((response) => {
          this.list = response.data.records
          this.total = response.data.total
          this.loading = false
        })
      } else {
        fetchList3(this.queryParam).then((response) => {
          this.list = response.data.records
          this.total = response.data.total
          this.loading = false
        })
      }
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    onImageError(event) {
      // 将事件的目标（即<img>元素）的src设置为本地占位图
      event.target.src = this.placeholderImage

      // 如果你想进一步处理错误，比如发送错误报告，可以在这里添加代码
      // ...
    },
    onClose() {
      const that = this
      that.visible = false
      this.ids = []
      this.selectedRowKeys = []
      this.selectedRows = []

      this.$emit('close')
    },
    handleOk() {
      // this.onClose()
      // this.$confirm({
      //   title: '是否确认关闭清空数据',
      //   onOk() {
      //   },
      //   onCancel() {},
      // })
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item.skuId)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    // 切换tabs
    callback(e) {
      this.active = e
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      let ids = []
      const postIds = row.id || this.ids
      if (row.id) {
        ids = [{ id: postIds }]
      } else {
        postIds.forEach((v) => {
          ids.push({ id: v })
        })
      }
      this.$confirm({
        title: '是否确认冻结此用户?',
        onOk() {
          return frozenTenant(ids).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('冻结成功', 3)
          })
        },
        onCancel() {},
      })
    },
  },
}
</script>
<style lang="less">
img {
  width: 80px;
  height: 80px;
}

.full-width-descriptions {
  width: 100% !important;
  // background: red;
  box-sizing: border-box;
  /* 确保包含内边距和边框 */
}

.ant-descriptions-item {
  width: 25%;
  // background: red;
}

.ant-descriptions-item-label {
  width: 100px;
  // background: red;
  text-align: right;
}
</style>
